// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"45f14798","400":"68eb6db6","479":"5b6b1611","775":"36488cee","795":"6b45b8ed"}[chunkId] + ".chunk.js";
};